export enum SnoozeOption {
  LATER_TODAY = 'later_today',
  TOMORROW = 'tomorrow',
  THIS_WEEKEND = 'this_weekend',
  NEXT_WEEK = 'next_week',
}

export const SNOOZE_OPTIONS_ORDER: SnoozeOption[] = [
  SnoozeOption.LATER_TODAY,
  SnoozeOption.TOMORROW,
  SnoozeOption.THIS_WEEKEND,
  SnoozeOption.NEXT_WEEK,
];

// Mirrors apps/api/src/utils/serverConstants.ts SNOOZE_MIN_LEAD_SECONDS — keep in sync.
export const SNOOZE_MIN_LEAD_SECONDS = 360;

const LATER_TODAY_HOUR = 18;
const MORNING_HOUR = 8;
const SATURDAY = 6;
const SUNDAY = 0;
const MONDAY = 1;

const atHour = (date: Date, hour: number): Date => {
  const result = new Date(date);
  result.setHours(hour, 0, 0, 0);
  return result;
};

const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const nextWeekday = (from: Date, targetDay: number): Date => {
  const daysUntilTarget = (targetDay - from.getDay() + 7) % 7 || 7;
  return addDays(from, daysUntilTarget);
};

export function getSnoozeOptionDate(
  option: SnoozeOption,
  now: Date = new Date(),
): Date {
  switch (option) {
    case SnoozeOption.LATER_TODAY:
      return atHour(now, LATER_TODAY_HOUR);
    case SnoozeOption.TOMORROW:
      return atHour(addDays(now, 1), MORNING_HOUR);
    case SnoozeOption.THIS_WEEKEND:
      return atHour(nextWeekday(now, SATURDAY), MORNING_HOUR);
    case SnoozeOption.NEXT_WEEK:
      return atHour(nextWeekday(now, MONDAY), MORNING_HOUR);
    default:
      throw new Error(`Unhandled snooze option: ${option satisfies never}`);
  }
}

export function getSnoozeOptionTimestamp(
  option: SnoozeOption,
  now: Date = new Date(),
): number {
  return Math.floor(getSnoozeOptionDate(option, now).getTime() / 1000);
}

export function isAfterMinLeadTime(
  epochSeconds: number,
  now: Date = new Date(),
): boolean {
  return epochSeconds * 1000 >= now.getTime() + SNOOZE_MIN_LEAD_SECONDS * 1000;
}

export function isSnoozeOptionAvailable(
  option: SnoozeOption,
  now: Date = new Date(),
): boolean {
  if (option === SnoozeOption.THIS_WEEKEND) {
    const day = now.getDay();
    if (day === SUNDAY || day === SATURDAY) {
      return false;
    }
  }

  return isAfterMinLeadTime(getSnoozeOptionTimestamp(option, now), now);
}
